import React from 'react';
import { Helmet } from 'react-helmet';
import Components from '../components/components';
import { stripNode } from '../helpers/get-contents';

const IndexPage = ({ data }) => {
    if (!data) {
        return <div>Landing page</div>;
    }

    const page = data.page.edges[0].node;
    const insights = stripNode(data.insights.edges);
    const locations = stripNode(data.locations.edges);
    const regions = stripNode(data.regions.edges);

    return (
        <div className="green-dividers">
            <Helmet>
                <body className="landingpage" />
            </Helmet>
            {page.modules.map((module, i) => (
                <Components
                    key={i}
                    content={module}
                    insights={insights}
                    locations={locations}
                    regions={regions}
                />
            ))}
        </div>
    );
};

export default IndexPage;

/*

query PageQusdasdasdsdfry {
  page: allMarkdownRemark (filter: { frontmatter:  { contenttype: { eq: "landing_page"}}}){
*/

export const IndexPageQuery = graphql`
    query SectionLasdfndinsdfssdfdfersdsdsdfffsdfssdfsddsfffdftegPageQsdfsduery1sfsdf1 {
        page: allDatoCmsLandingPage {
            edges {
                node {
                    modules {
                        __typename
                        ... on DatoCmsContactOnLandingpage {
                            title
                            people {
                                ...TraderFragment
                            }
                        }
                        ... on DatoCmsHero {
                            title
                            body
                            image {
                                ...HeroImageFragment
                            }
                            link {
                                slug
                            }
                            textlink
                            linktext
                        }
                        ... on DatoCmsGiantLinksModule {
                            links {
                                ...GiantLinkFragment
                            }
                        }
                        ... on DatoCmsLinksToInsight {
                            title
                        }

                        ... on DatoCmsMapForLandingpage {
                            title
                            map
                            citylist
                        }
                        ... on DatoCmsIconLinksCollection {
                            title
                            links {
                                pageName
                                descriptionForLinks
                                iconForLinks {
                                    sizes(maxWidth: 50) {
                                        base64
                                        aspectRatio
                                        src
                                        srcSet
                                        sizes
                                    }
                                }
                                slug
                                parentPage {
                                    slug
                                }
                            }
                        }
                        ... on DatoCmsMiniHero {
                            title
                            body
                            image {
                                ...HeroImageFragment
                            }
                        }
                    }
                }
            }
        }
        insights: allDatoCmsInsightPage(
            limit: 4
            sort: { fields: [date], order: DESC }
        ) {
            edges {
                node {
                    ...InsightCardFragment
                }
            }
        }
        locations: allDatoCmsLocation(
            sort: { fields: [position], order: ASC }
        ) {
            edges {
                node {
                    ...LocationFragment
                }
            }
        }
        # locations: allDatoCmsLocation(filter: { root: { eq: true } }, sort: {fields: [position], order: ASC}) {
        #   edges {
        #     node {
        #       ...LocationFragment
        #       treeChildren {
        #         ...LocationFragment
        #       }
        #     }
        #   }
        # }
        regions: allDatoCmsRegion(sort: { fields: [position], order: ASC }) {
            edges {
                node {
                    region
                    position
                }
            }
        }
    }
`;

// date(formatString: "MMMM DD, YYYY")



// WEBPACK FOOTER //
// ./src/templates/landingpage-template.js